import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { SubViewport } from './Component';
nodeComponentRegistry.register({ typeName: 'SubViewport', Component: SubViewport });
//# sourceMappingURL=index.r3f.js.map